export const SET_SERVICES = 'SET_SERVICES';
export const SET_SERVICE = 'SET_SERVICE';
export const ADD_SERVICE = 'ADD_SERVICE';
export const UPDATE_SERVICE = 'UPDATE_SERVICE';
export const REMOVE_SERVICE = 'REMOVE_SERVICE';
export const CLEAR_SERVICE = 'CLEAR_SERVICE';
export const CLEAR_SERVICES = 'CLEAR_SERVICES';
